import {useState} from 'react'
import {KTIcon} from '../../../../../_metronic/helpers'
import {useListView} from '../../core/ListViewProvider'
import {Filter} from './Filter'
import {SampleClassifiedModal} from './SampleClassifiedModal'
import {ListFailedProvider} from '../../core/ListFailedProvider'

const ListToolbar = () => {
  const {setItemIdForUpdate} = useListView()
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  const openAddModal = () => {
    setItemIdForUpdate(null)
  }
  const openSampleModal = () => setIsModalOpen(true)
  const closeSampleModal = () => setIsModalOpen(false)

  return (
    <>
      <ListFailedProvider>
        {isModalOpen && (
          <SampleClassifiedModal
            fileName={'sample_classified_data.xlsx'}
            closeSampleModal={closeSampleModal}
          />
        )}
      </ListFailedProvider>
      <div className='d-flex justify-content-end' data-kt-user-table-toolbar='base'>
        <Filter />
        <button onClick={openSampleModal} type='button' className='btn btn-light-primary me-3'>
          <KTIcon iconName='exit-down' className='fs-2' />
          Import
        </button>
        <button type='button' className='btn btn-primary' onClick={openAddModal}>
          <KTIcon iconName='plus' className='fs-2' />
          Add Post
        </button>
      </div>
    </>
  )
}

export {ListToolbar}

